import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/signin");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        setUser(res.data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { state: { user: res.data } });
      } catch {
        navigate("/signin");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="grid-bg flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mx-auto mb-6 h-12 w-12 animate-spin border-2 border-edge border-t-yellow" />
        <p className="font-mono text-xs uppercase tracking-widest text-gray-400">Securing field session…</p>
      </div>
    </div>
  );
}
